import { isEmpty } from "lodash"
import React from "react"
import BootstrapTable from "react-bootstrap-table-next"
import filterFactory from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"
import { useTranslation } from "react-i18next"

const RemotePagination = ({
    data,
    page,
    sizePerPage,
    onTableChange,
    totalSize,
    columns,
    keyField,
    expandRow,
    props,
    selectRow = {},
    remote = true
}: {
    data: any
    page: number
    sizePerPage: number
    onTableChange: any
    totalSize: number
    columns: any
    keyField: string
    expandRow: any
    props: any
    selectRow?: Record<string, any>
    remote?: boolean
}) => {
    const { t } = useTranslation()
    return (
        <div>
            <BootstrapTable
                remote={remote}
                pagination={remote ? paginationFactory({ page, sizePerPage, totalSize }) : undefined}
                onTableChange={onTableChange}
                {...(expandRow && !isEmpty(expandRow) ? { expandRow } : {})}
                wrapperClasses="table-wrapper my-3 "
                headerClasses="header-class font-13"
                bordered={false}
                noDataIndication={t("No_Record")}
                filter={filterFactory()}
                rowClasses="custom-table-row"
                condensed={true}
                {...(selectRow && !isEmpty(selectRow) ? { selectRow } : {})}
                {...props.baseProps}
            />
        </div>
    )
}

export default RemotePagination
